module.exports = __webpack_public_path__ + "static/media/faisal1.13048353.jpg";